import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingMandatorySettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingMandatorySettingsEntity
